export default "__VITE_ASSET__BK3_AAYl__"